import React from 'react';

import BaseComponent from '../../../../baseClasses/BaseComponent';
import './ReferenceDocumentUploadCard.scss';
import ProgressIndicator from '../../../../components/ProgressIndicator';
import fileTypePdfIcon from '../../../../assets/images/pdf-blue.png';
import fileTypeDocIcon from '../../../../assets/images/doc-blue.png';
import fileTypeXlsIcon from '../../../../assets/images/xls-blue.png';
import fileTypeMovIcon from '../../../../assets/images/video-blue.png';
import fileTypeOtherIcon from '../../../../assets/images/other-blue.png';

// Change DialogButton to the appropriate name
class ReferenceDocumentUploadCard extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { };
  }

  handleDetermineFileType(type){
    if(type){
      switch(type){
      case 'pdf':
        return fileTypePdfIcon;
      case 'xls':
      case 'xlt':
      case 'xlm':
      case 'xlsm':
      case 'xlsx':
      case 'xltx':
        return fileTypeXlsIcon;
      case 'docx':
      case 'doc':
      case 'rtf':
      case 'txt':
        return fileTypeDocIcon;
      case 'jpg':
      case 'jpeg':
      case 'png':
        return this.props.file.preview;
      case 'mp4':
      case 'mp4v':
      case 'mov':
      case 'm4v':
      case '3gp':
      case 'wmv':
      case 'flv':
      case 'qt':
        return fileTypeMovIcon;
      default:  
        return fileTypeOtherIcon;
      }
    }
    return fileTypeOtherIcon;
  }

  render() {

    const { file } = this.props;
    let content = <ProgressIndicator 
      width={136} 
      height={1}
      marginLeft={17}
    />;
    if(file.finished){
      content = (
        <div className='ref-doc-upload-details'>
          <div className='ref-doc-file-name'>{file.file ? file.file.name : 'File name not found'}</div>
          {file.successful 
          ? <div className='ref-doc-upload-success' /> 
          : <div className='ref-doc-upload-failure' />
          }
        </div>
      );
    }
    let fileType = this.handleDetermineFileType(file.ext);

    return (
      <div key={'ref-doc-card-' + Math.floor(Math.random() * 1000)}className="ref-docs-upload-card" >
        <img className='image-placeholder' src={fileType} alt="reference doc upload" />
        {content}
      </div>
    );
  }
}

export default ReferenceDocumentUploadCard;



// WEBPACK FOOTER //
// ./src/containers/ReferenceDocumentsLibrary/ReferenceDocumentsUploader/ReferenceDocumentUploadCard/index.js